import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import JumboCardQuick from '@jumbo/components/JumboCardQuick'
import Typography from '@mui/material/Typography'
import { TabContext, TabPanel } from '@mui/lab'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import { selectItemById, updateCustomer, getCustomerById } from 'app/redux/store/features/customers'
import UpdateCustomerForm from './UpdateCustomerForm'
import utilServices from 'app/services/util-services'
import CustomerActivity from '../CustomerActivity/CustomerActivity'
import { useJumboTheme } from '@jumbo/hooks'
import { IconButton, Stack, useMediaQuery } from '@mui/material'
import WestIcon from '@mui/icons-material/West'

const UpdateCustomer = () => {
    const [tabTitle, setTabTitle] = React.useState('customerdetails')
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { enqueueSnackbar } = useSnackbar()
    const { state } = useLocation()
    const { customerId } = state
    const { customers, loading, error } = useSelector((state) => state.customers)
    const customer = selectItemById(customers, customerId)
    const [apiCallInProgress, setApiCallInProgress] = useState(false)
    const includeBalance = true
    const { theme } = useJumboTheme()
    const sm = useMediaQuery(theme.breakpoints.down('sm'))

    useEffect(() => {
        if (utilServices.isNullOrUndefined(customer.id))
            dispatch(getCustomerById({ id: customerId, includeBalance: includeBalance }))
    }, [])

    useEffect(() => {
        if (!apiCallInProgress || loading) return
        setApiCallInProgress(false)

        if (error) handleError(error)
        else {
            enqueueSnackbar('Customer updated successfully', {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
            navigate('/registrations/customers')
        }
    }, [loading])

    function handleError(error) {
        if (error.status === '401') {
            navigate('/profile/signout')
        } else if (error.detail) {
            enqueueSnackbar(error.detail, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        } else {
            enqueueSnackbar(error, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        }
    }

    const onTabSelectionChanged = (e, newValue) => {
        setTabTitle(newValue)
    }

    const onUpdateCustomer = async () => {
        setApiCallInProgress(true)
        dispatch(updateCustomer({ ...customer }))
    }

    return (
        <React.Fragment>
            <JumboCardQuick
                noWrapper
                title={
                    <Stack direction='row' alignItems='center' spacing={1}>
                        <IconButton
                            className='backArrowForm'
                            onClick={() =>
                                navigate(`/registrations/customers`, {
                                    state: { navigateFrom: 'cancel-update-customer' },
                                })
                            }>
                            <WestIcon />
                        </IconButton>
                        <Typography color={'common.white'} variant={'h3'} sx={{ mt: 0.8 }}>
                            Update Customer {'(' + (customer?.firstName ?? '') + ' ' + (customer?.lastName ?? '') + ')'}
                        </Typography>
                    </Stack>
                }
                headerSx={{
                    height: 40,
                    bgcolor: 'primary.main',
                }}>
                <TabContext value={tabTitle}>
                    <TabList
                        sx={{ bgcolor: 'background.default', m: 2, mb: 0, marginLeft: '23px', marginRight: '23px' }}
                        onChange={onTabSelectionChanged}>
                        <Tab
                            label={'Customer Details'}
                            value={'customerdetails'}
                            sx={{ width: sm ? '160px' : '190px' }}
                        />
                        <Tab
                            label={'Customer Activity'}
                            value={'customeractivity'}
                            sx={{ width: sm ? '160px' : '190px' }}
                        />
                    </TabList>
                    <TabPanel value='customerdetails'>
                        <UpdateCustomerForm customerData={customer} updateCustomer={onUpdateCustomer} />
                    </TabPanel>
                    <TabPanel value='customeractivity'>
                        <CustomerActivity customerId={customerId} />
                    </TabPanel>
                </TabContext>
            </JumboCardQuick>
        </React.Fragment>
    )
}

export default UpdateCustomer
